import { render, staticRenderFns } from "./GoPro.vue?vue&type=template&id=ec5e8d06&scoped=true"
import script from "./GoPro.vue?vue&type=script&lang=js"
export * from "./GoPro.vue?vue&type=script&lang=js"
import style0 from "./GoPro.vue?vue&type=style&index=0&id=ec5e8d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5e8d06",
  null
  
)

export default component.exports